var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/thumb-navigation.tsx";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ThumbNavigationLink from 'soapbox/components/thumb-navigation-link';
import { useAppSelector, useOwnAccount } from 'soapbox/hooks';
import { getFeatures } from 'soapbox/utils/features';

const ThumbNavigation = () => {
  const account = useOwnAccount();
  const notificationCount = useAppSelector(state => state.notifications.unread);
  const chatsCount = useAppSelector(state => state.chats.items.reduce((acc, curr) => acc + Math.min(curr.unread || 0, 1), 0));
  const dashboardCount = useAppSelector(state => state.admin.openReports.count() + state.admin.awaitingApproval.count());
  const features = getFeatures(useAppSelector(state => state.instance));
  /** Conditionally render the supported messages link */

  const renderMessagesLink = () => {
    if (features.chats) {
      return /*#__PURE__*/React.createElement(ThumbNavigationLink, {
        src: require('@tabler/icons/messages.svg'),
        text: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "navigation.chats",
          defaultMessage: "Chats",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 21,
            columnNumber: 17
          }
        }),
        to: "/chats",
        exact: true,
        count: chatsCount,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 19,
          columnNumber: 9
        }
      });
    }

    if (features.directTimeline || features.conversations) {
      return /*#__PURE__*/React.createElement(ThumbNavigationLink, {
        src: require('@tabler/icons/mail.svg'),
        text: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "navigation.direct_messages",
          defaultMessage: "Messages",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 33,
            columnNumber: 17
          }
        }),
        to: "/messages",
        paths: ['/messages', '/conversations'],
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 31,
          columnNumber: 9
        }
      });
    }

    return null;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "thumb-navigation",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ThumbNavigationLink, {
    src: require('@tabler/icons/home.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "navigation.home",
      defaultMessage: "Home",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 15
      }
    }),
    to: "/",
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ThumbNavigationLink, {
    src: require('@tabler/icons/search.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "navigation.search",
      defaultMessage: "Search",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54,
        columnNumber: 15
      }
    }),
    to: "/search",
    exact: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 7
    }
  }), account && /*#__PURE__*/React.createElement(ThumbNavigationLink, {
    src: require('@tabler/icons/bell.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "navigation.notifications",
      defaultMessage: "Alerts",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 62,
        columnNumber: 17
      }
    }),
    to: "/notifications",
    exact: true,
    count: notificationCount,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 9
    }
  }), account && renderMessagesLink(), account && account.staff && /*#__PURE__*/React.createElement(ThumbNavigationLink, {
    src: require('@tabler/icons/dashboard.svg'),
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "navigation.dashboard",
      defaultMessage: "Dashboard",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 74,
        columnNumber: 17
      }
    }),
    to: "/soapbox/admin",
    count: dashboardCount,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 9
    }
  }));
};

export default ThumbNavigation;